import {isSignedIn} from './'
import {getMember} from '@vista/omnichannel-components-domain'

export const isMemberSignInCultOrClassic = ():boolean => isSignedIn() ? getMember()?.subscriptions !== null : false